import {PLATFORM_REVIEW_BUTTONS} from './platform-review-buttons.model';
import {PlatformReviewForm} from './platform-review-form.model';
import {TargetPlatformReview} from './target-platform-review.model';

/**
 * Réglages prêtés à une invitation qui n'existe pas — le rang demandé ne désigne aucun élément.
 *
 * Ils valent ceux d'une invitation neuve : le cas général, sans lien, ouverte à côté du
 * questionnaire. Un formulaire amorcé dessus ne montrera rien d'aberrant le temps que la carte
 * retrouve son élément.
 */
export const DEFAULT_PLATFORM_REVIEW_FORM: PlatformReviewForm = {
    site: TargetPlatformReview.OTHER,
    link: '',
    buttonFontColor: PLATFORM_REVIEW_BUTTONS[TargetPlatformReview.OTHER].fontColor,
    buttonBackgroundColor: PLATFORM_REVIEW_BUTTONS[TargetPlatformReview.OTHER].backgroundColor,
    openNewTab: true,
};
